import { fetchBaseQuery } from '@reduxjs/toolkit/dist/query';
import { localStorageService } from './localStorageService';
import { CLOUD_FETCH_TIMEOUT, getBaseUrl } from './apiConfig';

const getBaseManagementUrl = () => {
  switch (window.__RUNTIME_CONFIG__.REACT_APP_MGH_ENV) {
    case 'prod':
      return 'https://home-management-api.ultra.myglobalhome.co';
    case 'uat':
      return 'https://home-management-api.uat.mgh.beintrepid.co.uk';
    case 'qa':
      return 'https://home-management-api.qa.mgh.beintrepid.co.uk';
    default:
      return (
        import.meta.env.VITE_MGH_MANAGEMENT_API_OVERRIDE ||
        'https://home-management-api.test.mgh.beintrepid.co.uk'
      );
  }
};

export const baseManagementUrl = getBaseManagementUrl();

export const authFetchBaseQuery = (args: Parameters<typeof fetchBaseQuery>[0]) => {
  const fetchBaseQueryFn = fetchBaseQuery({
    prepareHeaders: (headers) => {
      headers.set('Authorization', `Bearer ${localStorageService.getTokens()?.accessToken}`);
      return headers;
    },
    ...args,
  });

  const authFetchBaseQueryFn = fetchBaseQuery({
    ...args,
    timeout: CLOUD_FETCH_TIMEOUT,
  });

  return async (...args: Parameters<typeof fetchBaseQueryFn>) => {
    const homeApiUrl = getBaseUrl();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_, ...restArgs] = args;

    const result = await fetchBaseQueryFn(...args);

    if (result.error && result.error.status === 401) {
      const refreshTokenResult = await authFetchBaseQueryFn(
        {
          url: `${homeApiUrl}/user/token/refresh`,
          method: 'POST',
          body: {
            email: localStorageService.getUser(),
            token: localStorageService.getTokens()?.refreshToken,
          },
        },
        ...restArgs,
      );

      if (refreshTokenResult.error) {
        console.error(refreshTokenResult.error);
        localStorageService.clearTokens();
        location.reload();
      }

      if (refreshTokenResult.data) {
        const refreshTokenData = refreshTokenResult.data as { token: string };
        localStorageService.setAccessToken(refreshTokenData.token);
        return fetchBaseQueryFn(...args);
      }
    }

    return result;
  };
};
